import { createContext } from 'react';

const I18nContext = /*#__PURE__*/createContext(undefined);

export { I18nContext };
